import mixpanel from 'mixpanel-browser';

export function usePreviewAnalytics() {
  function trackSectionViewed(count: number): void {
    try {
      mixpanel.track('preview_section_viewed', {
        total_plugins_displayed: count,
      });
    } catch (_e) {
      // silent
    }
  }

  function trackPluginClicked(
    name: string,
    tags: string[],
    position: number,
    source: string,
  ): void {
    try {
      mixpanel.track('preview_plugin_clicked', {
        plugin_name: name,
        plugin_tags: tags,
        card_position: position,
        source,
      });
    } catch (_e) {
      // silent
    }
  }

  function trackSearched(query: string, count: number): void {
    try {
      mixpanel.track('preview_searched', {
        search_query: query,
        results_count: count,
      });
    } catch (_e) {
      // silent
    }
  }

  function trackFeedbackLinkClicked(pluginName: string): void {
    try {
      mixpanel.track('preview_feedback_link_clicked', {
        plugin_name: pluginName,
      });
    } catch (_e) {
      // silent
    }
  }

  return {
    trackSectionViewed,
    trackPluginClicked,
    trackSearched,
    trackFeedbackLinkClicked,
  };
}
